import { create } from 'zustand';
import { persist, devtools } from 'zustand/middleware';

export type ThemePreference = 'system' | 'light' | 'dark';

interface ThemeState {
  /** User's explicit choice; 'system' follows prefers-color-scheme */
  preference: ThemePreference;
  setPreference: (preference: ThemePreference) => void;
}

export const useThemeStore = create<ThemeState>()(
  devtools(
    persist(
      (set) => ({
        preference: 'system',
        setPreference: (preference) => set({ preference }),
      }),
      { name: 'monta-theme' }
    ),
    { name: 'ThemeStore' }
  )
);
